import React from 'react';
import {connect} from 'react-redux';
import {AppState} from '@Redux/store';
import {TeamView} from "@Selectors/builder/myBuilder/show/view/TeamView";
//@ts-ignore
import img_all_versions from "@Images/en/all_versions.png";

interface IMyTeamComponentProps {
  team: TeamView
}

const TeamComponent: React.FC<MyTeamComponentProps> = ({team}) => {
  return (
    <div className="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-2 team cursor-pointer tournament_list_row">
      <a href={`/${document.documentElement.lang}/tournament/my_teams/${team.id}`}>
        <img className="img-fluid w-100" alt={'9Th Age'} src={`${process.env.CDN ?? ''}${img_all_versions}`} />
        <h4 className="boxtitre text-center"><span className="user-name">{team.eventName}: {team.name}</span>
          {team.isLeader && <i className="fas fa-user-shield"></i>}
        </h4>
      </a>
    </div>
  );
};

const mapStateToProps = (state: AppState, owsProps: IMyTeamComponentProps) => ({
  team: owsProps.team
})

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(TeamComponent);

type MyTeamComponentProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
